export class AppConfig {
   static apiUrl = process.env.REACT_APP_API_URL;
   static meilisearchUrl = process.env.REACT_APP_MEILISEARCH_URL;
}
